<template lang="html">
  <div id="product-detail-page" class="bg-white">
    <!-- Breadcrumb -->
    <!-- <div class="bg-light py-4">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0 bg-transparent p-0">
            <li class="breadcrumb-item">
              <router-link to="/" class="text-secondary">Inicio</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/productos?cat&page=1" class="text-secondary">Productos</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ product.name }}</li>
          </ol>
        </nav>
      </div>
    </div> -->

    <loading-component-s1 v-if="isLoading"></loading-component-s1>

    <div class="container py-4 py-lg-5" v-else>
      <!-- Botón volver -->
      <router-link
        :to="($route.name == 'productDescriptionPage') ? '/productos?cat&page=1' : 
          ($route.name == 'familyDescriptionPage') ? '/soluciones-tech?page=1' : '/drones?page=1'"
        class="d-inline-flex align-items-center text-secondary mb-4 text-decoration-none">
        <i class="fa-solid fa-arrow-left mr-2"></i>
        Volver a productos
      </router-link>

      <div class="row">
        <!-- Imágenes del producto -->
        <div class="col-12 col-lg-6 mb-4 mb-lg-0 col-left">
          <div class="d-block text-center" style="opacity: 0.4;" v-if="product.images.length == 0">
            <img class="img-fluid" src="public/images/logo.png">
          </div>

          <swiper class="mb-1 swiper swiper-s1" :options="galleryOptions" v-else>
            <swiper-slide v-for="(image, imgInx) in product.images" :key="'imgInx-'+imgInx">
              <div class="aspect-square bg-light rounded overflow-hidden b-image">
                <img class="placed-backg" src="public/images/shared/empty.png" :style="{ backgroundImage: 'url('+image+')' }" />
              </div>
            </swiper-slide>
            
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>

          <!-- <div class=" mb-3">
            <div
              class="aspect-square bg-light rounded overflow-hidden"
              style="aspect-ratio: 1/1; max-height: 560px;"
            >
              <img
                :src="product.images[selectedImage] || placeholderImage"
                :alt="product.name"
                class="w-100 h-100 object-fit-cover"
                style="object-fit: cover;"
              />
            </div>
          </div>
          <div class="row no-gutters">
            <div
              v-for="(image, index) in product.images"
              :key="index"
              class="col-3 px-1"
            >
              <button
                type="button"
                class="btn btn-link p-0 w-100 border rounded overflow-hidden"
                :class="selectedImage === index ? 'border-danger' : 'border-secondary'"
                @click="selectedImage = index"
              >
                <img
                  :src="image || placeholderImage"
                  :alt="`${product.name} ${index + 1}`"
                  class="w-100"
                  style="aspect-ratio: 1/1; object-fit: cover; max-height: 80px;"
                />
              </button>
            </div>
          </div> -->

          <!-- <div class="mt-4">
            <b-button
              variant="primary"
              block
              class="mb-2"
              @click="showRentalModal = true"
            >
              <i class="fa-solid fa-calendar-alt mr-2"></i>
              Arriendo Disponible
            </b-button>
            <b-button
              variant="success"
              block
              class="mb-2"
              @click="showContactModal = true"
            >
              <i class="fa-solid fa-user-check mr-2"></i>
              Contacta a un vendedor
            </b-button>
            <b-button
              variant="info"
              block
              class="mb-2"
              @click="showDemoModal = true"
            >
              <i class="fa-solid fa-desktop mr-2"></i>
              Solicita tu demo
            </b-button>
          </div> -->
        </div>

        <!-- Información del producto -->
        <div class="col-12 col-lg-6">
          <div class="mb-3">
            <span class="badge badge-secondary mb-2">{{ product.brand }}</span>
            <h1 class="h3 font-weight-bold text-dark mb-2">{{ product.name }}</h1>
            <!-- <div class="d-flex align-items-center mb-2">
              <div class="text-warning mr-2">
                <i
                  v-for="i in 5"
                  :key="i"
                  class="fa-solid fa-star"
                  :class="i <= Math.floor(product.rating) ? 'text-warning' : 'text-muted'"
                ></i>
              </div>
              <span class="text-muted small">
                {{ product.rating }} ({{ product.reviews }} reseñas)
              </span>
            </div> -->
          </div>

          <div class="mb-4">
            <div class="d-flex align-items-center flex-wrap mb-2">
              <span class="h4 font-weight-bold text-danger mr-2" v-if="product.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }}</span>
              <span class="h4 font-weight-bold text-danger mr-2" v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</span>
              <span class="text-muted mr-2" style="text-decoration: line-through;" v-if="product.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</span>
              <span class="badge badge-danger" v-if="product.price_offer">Oferta</span>
            </div>
            <p class="text-muted small mb-0">Precio en USD. Incluye IVA.</p>
          </div>

          <p class="text-secondary mb-4">{{ product.description }}</p>

          <!-- Selección de kit -->
          <div class="mb-4" v-if="product.kits.length > 0">
            <h3 class="h6 font-weight-bold text-dark mb-3">Selecciona tu kit:</h3>
            <div class="form-group box-kits-info">
              <div
                v-for="(kit, kInx) in product.kits"
                :key="'mInx-'+kInx"
                class="custom-control custom-radio mb-2 p-0 border rounded"
                :class="selectedKit === kInx ? 'border-danger bg-light' : 'border-secondary'"
              >
                <input
                  :id="'kit-' + kInx"
                  v-model="selectedKit"
                  type="radio"
                  :value="kInx"
                  class="custom-control-input"
                />
                <label :for="'kit-' + kInx" class="custom-control-label w-100 cursor-pointer p-3">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <span class="font-weight-bold">{{ kit.title }}</span>
                    <div class="">
                      <span class="font-weight-bold text-danger" v-if="kit.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(kit.price_offer) }}</span>
                      <span class="font-weight-bold text-danger" v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(kit.price) }}</span>
                      <span class="text-muted small" style="text-decoration: line-through;" v-if="kit.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(kit.price) }}</span>
                    </div>
                  </div>

                  <div class="d-block box-kit-description" v-if="selectedKit === kInx" v-html="kit.description"></div>
                  <!-- <ul class="list-unstyled small text-muted mb-0 pl-0">
                    <li v-for="(item, i) in kit.includes.slice(0, 3)" :key="i">• {{ item }}</li>
                    <li v-if="kit.includes.length > 3" class="text-muted">
                      + {{ kit.includes.length - 3 }} elementos más
                    </li>
                  </ul> -->
                </label>
              </div>
            </div>
          </div>

          <b-form class="mb-4 box-cart" @submit.prevent="addCart()">
            <div class="box-quantity">
              <div class="_btn btn-minus t-150" @click="btnQuantity('minus')"><i class="fa-solid fa-minus"></i></div>
              <b-form-input class="" size="sm" v-model="form.quantity"></b-form-input>
              <div class="_btn btn-plus t-150" @click="btnQuantity('plus')"><i class="fa-solid fa-plus"></i></div>
            </div>
            <b-button class="btn btn-danger btn-lg text-decoration-none btn-add-to-cart" :class="{ 'disabled': product.stock <= 0 }" type="submit">
              <i class="fa-solid fa-cart-shopping mr-2"></i>
              {{ product.stock > 0 ? 'Agregar' : 'Agotado' }}
            </b-button>
            <!-- <div class="row no-gutters">
              <div class="col-6 pr-1">
                <b-button variant="outline-secondary" block size="sm">
                  <i class="fa-solid fa-heart mr-2"></i>
                  Favoritos
                </b-button>
              </div>
              <div class="col-6 pl-1">
                <b-button variant="outline-secondary" block size="sm">
                  <i class="fa-solid fa-share-alt mr-2"></i>
                  Compartir
                </b-button>
              </div>
            </div> -->
          </b-form>

          <!-- Estado de stock -->
          <div class="d-flex align-items-center">
            <span
              class="rounded-circle d-inline-block mr-2"
              :class="product.stock > 0 ? 'bg-success' : 'bg-danger'"
              style="width: 10px; height: 10px;"
            ></span>
            <span class="text-muted small">
              {{ product.stock > 0 ? 'En stock - Envío inmediato' : 'Agotado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Tabs de detalles del producto -->
      <div class="mt-5 pt-4 border-top">
        <ul class="nav nav-tabs border-bottom-0" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="activeTab === 'caracteristicas' ? 'active text-danger font-weight-bold' : 'text-secondary'"
              href="#"
              @click.prevent="activeTab = 'caracteristicas'"
            >
              Características
            </a>
          </li>
          <li class="nav-item" v-if="product.specifications_c1 || product.specifications_c2">
            <a
              class="nav-link"
              :class="activeTab === 'especificaciones' ? 'active text-danger font-weight-bold' : 'text-secondary'"
              href="#"
              @click.prevent="activeTab = 'especificaciones'"
            >
              Especificaciones
            </a>
          </li>
          <li class="nav-item" v-if="product.manuals.length > 0">
            <a
              class="nav-link"
              :class="activeTab === 'manuales' ? 'active text-danger font-weight-bold' : 'text-secondary'"
              href="#"
              @click.prevent="activeTab = 'manuales'"
            >
              Manuales
            </a>
          </li>
          <li class="nav-item" v-if="product.videos.length > 0">
            <a
              class="nav-link"
              :class="activeTab === 'videos' ? 'active text-danger font-weight-bold' : 'text-secondary'"
              href="#"
              @click.prevent="activeTab = 'videos'"
            >
              Videos
            </a>
          </li>
        </ul>

        <div class="tab-content py-4 box-tabs-info">
          <!-- Características -->
          <div v-if="activeTab === 'caracteristicas'" class="tab-pane" v-bind:class="{ 'active': activeTab === 'caracteristicas' }">
            <div class="box-specs-info">
              <div class="row">
                <div class="" :class="{ 'col-md-12': product.features_columns == 1, 'col-md-6': product.features_columns == 2 }">
                  <h3 class="h5 font-weight-bold text-dark mb-3">Características Principales</h3>
                  
                  <div class="d-block" v-html="product.features_c1"></div>
                </div>

                <div class="col-md-6" v-if="product.features_columns == 2">
                  <h3 class="h5 font-weight-bold text-dark mb-3">Especificaciones Técnicas Principales</h3>

                  <div class="d-block" v-html="product.features_c2"></div>
                  <!-- <table>
                    <tr>
                      <td><strong>Precisión Angular</strong></td>
                      <td><p style="text-align: right;"><strong>1" (0.3 mgon)</strong></p></td>
                    </tr>
                  </table>
                  <table>
                    <tr>
                      <td><strong>Alcance con Prisma</strong></td>
                      <td><p style="text-align: right;"><strong>3500m</strong></p></td>
                    </tr>
                  </table>
                  <table>
                    <tr>
                      <td><strong>Pantalla</strong></td>
                      <td><p style="text-align: right;"><strong>5" táctil a color</strong></p></td>
                    </tr>
                  </table> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Especificaciones -->
          <div v-if="activeTab === 'especificaciones'" class="tab-pane" v-bind:class="{ 'active': activeTab === 'especificaciones' }">
            
            <div class="box-specs-info">
              <div class="row">
                <div class="" :class="{ 'col-md-12': product.specifications_columns == 1, 'col-md-6': product.specifications_columns == 2 }">
                  <h3 class="h5 font-weight-bold text-dark mb-4">Especificaciones Técnicas Completas</h3>
                  
                  <div class="d-block" v-html="product.specifications_c1"></div>
                </div>

                <div class="col-md-6" v-if="product.specifications_columns == 2">
                  <div class="d-block" v-html="product.specifications_c2"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Manuales -->
          <div v-if="activeTab === 'manuales'" class="tab-pane" v-bind:class="{ 'active': activeTab === 'manuales' }">
            <h3 class="h5 font-weight-bold text-dark mb-4">Manuales y Documentación</h3>
            <div class="row">
              <div
                v-for="(manual, mInx) in product.manuals"
                :key="'mInx-'+mInx"
                class="col-12 col-md-6 mb-3"
              >
                <div class="card border h-100 hover-border-danger">
                  <div class="card-body d-flex align-items-start justify-content-between">
                    <div class="flex-grow-1">
                      <h4 class="h6 font-weight-bold text-dark mb-2">{{ manual.title }}</h4>
                      <p class="small text-muted mb-1">Tipo: {{ manual.file_extension }}</p>
                      <p class="small text-muted mb-1">Tamaño: {{ manual.file_size }}</p>
                      <p class="small text-muted mb-0">Idioma: {{ manual.language }}</p>
                    </div>
                    <a class="btn ml-2 btn-outline-secondary btn-sm" target="_blank" :href="manual.document" download>
                      <i class="fa-solid fa-download mr-1"></i>
                      Descargar
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Videos -->
          <div v-if="activeTab === 'videos'" class="tab-pane" v-bind:class="{ 'active': activeTab === 'videos' }">
            <h3 class="h5 font-weight-bold text-dark mb-4">Videos Tutoriales</h3>
            <div class="row">
              <div
                v-for="(video, vInx) in product.videos"
                :key="'vInx-'+vInx"
                class="col-12 col-md-6 col-lg-4 mb-4"
              >
                <div class="card border h-100 hover-border-danger overflow-hidden">
                  <div class="position-relative cursor-pointer" @click="openVideoModal(video.video_url)">
                    <img
                      :src="video.thumbnail || placeholderImage"
                      :alt="video.title"
                      class="card-img-top"
                      style="height: 180px; object-fit: cover;"
                    />
                    <div
                      class="position-absolute d-flex align-items-center justify-content-center"
                      style="top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.4);"
                    >
                      <b-button variant="light" size="sm">
                        <i class="fa-solid fa-play mr-2"></i>
                        Reproducir
                      </b-button>
                    </div>
                    <!-- <span
                      class="position-absolute badge badge-dark"
                      style="bottom: 8px; right: 8px;"
                    >
                      {{ video.duration }}
                    </span> -->
                  </div>
                  <!-- <div class="card-body">
                    <h4 class="h6 font-weight-bold text-dark mb-0">{{ video.title }}</h4>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Arriendo -->
    <b-modal
      v-model="showRentalModal"
      title="Arriendo Disponible"
      hide-footer
      centered
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template #modal-title>
        <span class="d-flex align-items-center">
          <i class="fa-solid fa-calendar-alt mr-2"></i>
          Arriendo Disponible
        </span>
      </template>
      <p class="text-muted small mb-3">
        Completa el formulario y un asesor se pondrá en contacto contigo para ofrecerte las mejores opciones de arriendo.
      </p>
      <b-form @submit.prevent="submitRental">
        <b-form-group label="Nombre completo *" label-for="rental-name">
            <b-form-input id="rental-name" v-model="rentalForm.name" type="text" required />
          </b-form-group>
          <b-form-group label="Email *" label-for="rental-email">
            <b-form-input id="rental-email" v-model="rentalForm.email" type="email" required />
          </b-form-group>
          <b-form-group label="Teléfono *" label-for="rental-phone">
            <b-form-input id="rental-phone" v-model="rentalForm.phone" type="tel" required />
          </b-form-group>
          <b-form-group label="Periodo de arriendo *" label-for="rental-period">
            <b-form-select id="rental-period" v-model="rentalForm.period" required>
              <option value="">Selecciona un periodo</option>
              <option value="1-7">1-7 días</option>
              <option value="1-2s">1-2 semanas</option>
              <option value="1m">1 mes</option>
              <option value="3m">3 meses</option>
              <option value="6m">6 meses o más</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Comentarios" label-for="rental-comments">
            <b-form-textarea
              id="rental-comments"
              v-model="rentalForm.comments"
              rows="3"
              placeholder="Cuéntanos más sobre tus necesidades..."
            />
          </b-form-group>
          <b-button type="submit" variant="primary" block>Solicitar cotización</b-button>
      </b-form>
    </b-modal>

    <!-- Modal Contactar vendedor -->
    <b-modal
      v-model="showContactModal"
      title="Contacta a un vendedor"
      hide-footer
      centered
      header-bg-variant="success"
      header-text-variant="white"
    >
      <template #modal-title>
        <span class="d-flex align-items-center">
          <i class="fa-solid fa-user-check mr-2"></i>
          Contacta a un vendedor
        </span>
      </template>
      <p class="text-muted small mb-3">
        Programa una llamada con nuestro equipo de ventas.
      </p>
      <b-form @submit.prevent="submitContact">
        <b-form-group label="Nombre completo *" label-for="contact-name">
          <b-form-input id="contact-name" v-model="contactForm.name" type="text" required />
        </b-form-group>
        <b-form-group label="Email *" label-for="contact-email">
          <b-form-input id="contact-email" v-model="contactForm.email" type="email" required />
        </b-form-group>
        <b-form-group label="Teléfono *" label-for="contact-phone">
          <b-form-input
            id="contact-phone"
            v-model="contactForm.phone"
            type="tel"
            required
            placeholder="+52 (XXX) XXX-XXXX"
          />
        </b-form-group>
        <b-form-group label="Fecha preferida *" label-for="contact-date">
          <b-form-input id="contact-date" v-model="contactForm.date" type="date" required />
        </b-form-group>
        <b-form-group label="Hora preferida *" label-for="contact-time">
          <b-form-select id="contact-time" v-model="contactForm.time" required>
            <option value="">Selecciona una hora</option>
            <option value="9-11">9:00 AM - 11:00 AM</option>
            <option value="11-13">11:00 AM - 1:00 PM</option>
            <option value="13-15">1:00 PM - 3:00 PM</option>
            <option value="15-17">3:00 PM - 5:00 PM</option>
          </b-form-select>
        </b-form-group>
        <b-button type="submit" variant="success" block>Agendar llamada</b-button>
      </b-form>
    </b-modal>

    <!-- Modal Solicitar demo -->
    <b-modal
      v-model="showDemoModal"
      title="Solicita tu demo"
      hide-footer
      centered
      header-bg-variant="info"
      header-text-variant="white"
    >
      <template #modal-title>
        <span class="d-flex align-items-center">
          <i class="fa-solid fa-desktop mr-2"></i>
          Solicita tu demo
        </span>
      </template>
      <p class="text-muted small mb-3">
        Agenda una demostración personalizada del producto.
      </p>
      <b-form @submit.prevent="submitDemo">
        <b-form-group label="Nombre completo *" label-for="demo-name">
          <b-form-input id="demo-name" v-model="demoForm.name" type="text" required />
        </b-form-group>
        <b-form-group label="Email *" label-for="demo-email">
          <b-form-input id="demo-email" v-model="demoForm.email" type="email" required />
        </b-form-group>
        <b-form-group label="Teléfono *" label-for="demo-phone">
          <b-form-input id="demo-phone" v-model="demoForm.phone" type="tel" required />
        </b-form-group>
        <b-form-group label="Fecha preferida *" label-for="demo-date">
          <b-form-input id="demo-date" v-model="demoForm.date" type="date" required />
        </b-form-group>
        <b-form-group label="Tipo de demo *" label-for="demo-type">
          <b-form-select id="demo-type" v-model="demoForm.type" required>
            <option value="">Selecciona un tipo</option>
            <option value="virtual">Virtual (videollamada)</option>
            <option value="presencial">Presencial</option>
          </b-form-select>
        </b-form-group>
        <b-button type="submit" variant="info" block>Solicitar demo</b-button>
      </b-form>
    </b-modal>

    <!-- Modal Video -->
    <b-modal
      v-model="showVideoModal"
      title="Video"
      hide-footer
      centered
      header-bg-variant="secondary"
      header-text-variant="white"
    >
      <template #modal-title>
        <span class="d-flex align-items-center">
          <i class="fa-solid fa-desktop mr-2"></i>
          Video
        </span>
      </template>
      <iframe v-if="videoUrl" width="100%" height="315" :src="getYoutubeID(videoUrl) + '?si=0000000000000000&rel=0&modestbranding=1'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </b-modal>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
      <div v-html="modal.msg"></div>
      <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
export default {

  data() {
    return {
      isLoading: true,
      id: null,

      videoUrl: '',
      selectedImage: 0,
      selectedKit: null,
      activeTab: 'caracteristicas',
      showRentalModal: false,
      showContactModal: false,
      showDemoModal: false,
      showVideoModal: false,
      placeholderImage: 'public/images/shared/placeholder.svg',
      
      rentalForm: {
        name: '',
        email: '',
        phone: '',
        period: '',
        comments: '',
      },

      contactForm: {
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
      },

      demoForm: {
        name: '',
        email: '',
        phone: '',
        date: '',
        type: '',
      },

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      form: {
        quantity: 0,
        products_models_id: null,
      },

      product: {
        id: null,
        name:  null,
        brand:  null,
        model:  null,
        price:  null,
        price_offer: null,
        rating: 4.8,
        reviews: 24,
        stock: 0,
        images: [
          // 'public/images/shared/placeholder.svg',
        ],
        description: null,

        manuals: [
          // { name: 'Manual de Usuario TS16 P', type: 'PDF', size: '12.5 MB', language: 'Español', url: '#' },
        ],

        videos: [
          // { title: 'Configuración Inicial TS16 P', duration: '8:45', thumbnail: 'public/images/shared/placeholder.svg', url: '#' },
        ],
        kits: [
          // {
          //   name: 'Kit Básico',
          //   price: '$45,999.00',
          //   includes: ['Estación Total TS16 P', 'Batería', 'Cargador', 'Manual', 'Certificado de calibración'],
          // },
          // {
          //   name: 'Kit Profesional',
          //   price: '$52,999.00',
          //   includes: [
          //     'Estación Total TS16 P',
          //     'Batería x2',
          //     'Cargador',
          //     'Trípode de madera',
          //     'Prisma circular',
          //     'Bastón prisma',
          //     'Maletín de transporte',
          //     'Manual',
          //     'Certificado de calibración',
          //   ],
          // },
          // {
          //   name: 'Kit Completo',
          //   price: '$59,999.00',
          //   includes: [
          //     'Estación Total TS16 P',
          //     'Batería x2',
          //     'Cargador',
          //     'Trípode de fibra de carbono',
          //     'Prisma circular x2',
          //     'Bastón prisma telescópico',
          //     'Maletín de transporte premium',
          //     'Software Leica Infinity',
          //     'Manual',
          //     'Certificado de calibración',
          //     'Soporte técnico 1 año',
          //   ],
          // },
        ],
      },

      // == Swiper options ==
      galleryOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
      // == ==
    };
  },

  methods: {
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      })
    },

    getProduct() {
      this.isLoading = true;
      axios.get(tools.url('/api/product/' + this.id)).then((response)=>{
        this.product = response.data;
        if(this.product.kits.length > 0) {
          this.selectedKit = 0;
        }
        // this.product.kits = response.data.kits;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getYoutubeID(url) {
      try {
        const parsed = new URL(url);
        const baseUrl = 'https://www.youtube.com/embed/';

        // Caso 1: youtu.be/VIDEO_ID
        if (parsed.hostname.includes('youtu.be')) {
          return baseUrl + parsed.pathname.slice(1);
        }

        // Caso 2: youtube.com/watch?v=VIDEO_ID
        if (parsed.searchParams.get('v')) {
          return baseUrl + parsed.searchParams.get('v');
        }

        // Caso 3: youtube.com/embed/VIDEO_ID
        if (parsed.pathname.includes('/embed/')) {
          return baseUrl + parsed.pathname.split('/embed/')[1];
        }

        return null;
      } catch {
        return null;
      }
    },

    openVideoModal(url) {
      this.showVideoModal = true;
      this.videoUrl = url;
    },

    btnQuantity(type) {
      if(type == 'plus') {
        if(this.product.stock > this.form.quantity) {
          this.form.quantity++;
        }
      } else {
        if(this.form.quantity > 1) {
          this.form.quantity--;
        }
      }
    },

    addCart(){
      if (!this.form.products_models_id) {
        this.modal.msg = 'Debes seleccionar una presentación';
        this.modal.icon = 'warning';
        this.$refs.modal.open();
        return;
      }
      
      var cart = [];
      var encontrado = false;

      if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.id && cart[i].products_models_id == this.form.products_models_id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.product.stock ? suma : this.product.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id:this.id, quantity:this.form.quantity,products_models_id:this.form.products_models_id });
            }
            console.log(cart);
            
          } else{
            cart.push({ id:this.id, quantity:this.form.quantity,products_models_id:this.form.products_models_id });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito';
          this.modal.icon = 'success';
          this.$refs.modal.open();
      }

    },

    submitRental() {
      console.log('Rental form:', this.rentalForm);
      this.showRentalModal = false;
      this.rentalForm = { name: '', email: '', phone: '', period: '', comments: '' };
    },

    submitContact() {
      console.log('Contact form:', this.contactForm);
      this.showContactModal = false;
      this.contactForm = { name: '', email: '', phone: '', date: '', time: '' };
    },

    submitDemo() {
      console.log('Demo form:', this.demoForm);
      this.showDemoModal = false;
      this.demoForm = { name: '', email: '', phone: '', date: '', type: '' };
    },
  },

  mounted() {
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getProduct();
  },

  watch: {
    "$route.params.id" : function(v){
      this.id = this.$root._getURLID(this.$route.params.id);

      this.getProduct();
    },

    "selectedKit": function(v){
      let kit = this.product.kits[v];

      this.product.price = (kit.price) ? kit.price : '';
      this.product.price_offer = (kit.price_offer) ? kit.price_offer : '';
      this.product.stock = (kit.stock) ? kit.stock : 0;

      this.form.products_models_id = kit.id;

      setTimeout(() => {
        if(this.product.stock > 0){
          this.form.quantity = 1;
        }
      }, 300);
    }
  },
};
</script>